import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import searchEngine from "../Asset/ESO/search-engine.svg";
import FileNamesvg from "../Asset/esocardicon/FileAccessibilityReport/FileName.svg"
import Scoresvg from "../Asset/esocardicon/FileAccessibilityReport/Score.svg"
import Grid from '@mui/material/Grid';
import {Container, Box, Badge} from '@mui/material';
import Commoncard from "../Commoncard";


const WordFile = (props) => {
  const [childcardData, setChildcardData] = useState([]);
  const navigate = useNavigate();
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const { jobid } = useParams();

  useEffect(() => {
    setChildcardData(props.cardData);
  }, [props.cardData]);

  const successRows = useMemo(() => (
    childcardData.detailed_data?.success?.map((row, index) => (
      <tr key={index}>
        <td style={{ color: '#000' }}>{index + 1}.</td>
        <td style={{ color: '#000' }}>{row}</td>
      </tr>
    ))
  ), [childcardData.detailed_data?.success]);

  const failureRows = useMemo(() => (
    childcardData.detailed_data?.failure?.map((row, index) => (
      <tr key={index}>
        <td style={{ color: '#000' }}>{index + 1}.</td>
        <td style={{ color: '#000' }}>{row}</td>
      </tr>
    ))
  ), [childcardData.detailed_data?.failure]);

  const WordFileCards = [
    {
      title: childcardData?.file_name, 
      value:  "File Name",
      iconSrc: FileNamesvg,
      bgColor: 1,
      iconColor: 1
    },
    {
      title: "Score",
      value: childcardData?.score,
      iconSrc: Scoresvg,
      bgColor: 2,
      iconColor: 2
    }
  ];

  return (
    <div className="cnt_hdr_file_access">

      <Container maxWidth={false} className="dashboard-card-container">
        <Box>
          <Grid container>
            <Grid container spacing={3} justifyContent="center">
              {WordFileCards.map((item, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Commoncard item={item} />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Box>
      </Container>


      {/* <div className="common-card-container" style={{ justifyContent: "center" }}>
        <div className={`common-card-wrapper-style cardactivecontainer`} style={{ cursor: 'default' }} >
          <div className={`common-card-icon-container`}>
            <div className={`common-card-icons`}>
              <img src={FileNamesvg} className={`common-card-icon-img`} alt="FileNamesvg" />
            </div>
          </div>
          <div className={`common-card-subtitle cardcontentactivecontainer`}>
            <span className="common-card-title">File Name</span>
            <span className="common-card-value">{childcardData.file_name}</span>
          </div>
        </div>
        <div className={`common-card-wrapper-style cardactivecontainer`} style={{ cursor: 'default' }} >
          <div className={`common-card-icon-container`}>
            <div className={`common-card-icons`}>
              <img src={Scoresvg} className={`common-card-icon-img`} alt="Scoresvg" />
            </div>
          </div>
          <div className={`common-card-subtitle cardcontentactivecontainer`}>
            <span className="common-card-title">Score</span>
            <span className="common-card-value">{childcardData.score}</span>
          </div>
        </div>
      </div> */}

      {/* <div className="cnt_audit_outer_wrap success_row success_summary" style={{ padding: '20px 0px'}}>
        <Grid container spacing={3} >
          <Grid item xs={6}>
            <div className="success_box" style={{ height: '100%' }}>
              <h3 className="success_message ">Success Report</h3>
              <div className="success_summary success_accordion success_details" style={{ height: '100%', }}>{successRows}</div>
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className="success_box" style={{ height: '100%' }}>
              <h3 className="failure_message">Failure Report</h3>
              <div className="success_summary success_accordion success_details" style={{ height: '100%', }}>{failureRows}</div>
            </div>
          </Grid>
        </Grid>
      </div> */}
      <div
        className="cnt_audit_outer_wrap success_row success_summary"
        style={{ padding: '20px 0px', height: '100%' }}>
        <Grid container spacing={3} alignItems="stretch">
          <Grid item xs={6} style={{ display: 'flex', flexDirection: 'column' }}>
            <div className="success_box" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              <h3 className="success_message">Success Report</h3>
              <div className="success_summary success_accordion success_details"
                style={{ flex: 1 }}>
                {successRows}
              </div>
            </div>
          </Grid>
          <Grid item xs={6} style={{ display: 'flex', flexDirection: 'column' }}>
            <div className="success_box" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              <h3 className="failure_message">Failure Report</h3>
              <div className="success_summary success_accordion success_details"
                style={{ flex: 1 }}>
                {failureRows}
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default WordFile;
